<template>
    <div :style="{height, width}" style="margin-block: 0.5rem;">
        <q-carousel
            v-model="slide"
            transition-prev="jump-right"
            transition-next="jump-left"
            swipeable
            infinite
            animated
            control-color="secondary"
            navigation
            padding
            arrows
            height="100%"
            class="shadow-1 rounded-borders"
        >   
            <q-carousel-slide 
                v-for="(chart, i) in charts" 
                :key="chart"
                :name="i"
                class="column no-wrap flex-center"
            >
                <div v-if="Array.isArray(chart)" class="chart-container">
                    <div 
                        class="chart-parent"
                        v-for="childChart in chart"
                        :key="childChart"
                    >
                        <component 
                            v-if="childChart?.type"
                            :is="childChart.type"
                            v-bind="{ chartData: childChart.data, chartOptions: childChart.options }"
                            @vue:mounted="loading = false"
                        />
                    </div>
                </div>
                <div v-else class="chart-container">
                    <div class="chart-parent">
                        <component 
                            :is="chart.type"
                            v-bind="{ chartData: chart.data, chartOptions: chart.options }"
                            @vue:mounted="loading = false"
                        />
                    </div>
                </div>
            </q-carousel-slide>
        </q-carousel>
    </div>
</template>

<script>
import Pie from "../ChartComponents/Pie.vue";
import Bar from "../ChartComponents/Bar.vue";
import Bubble from "../ChartComponents/Bubble.vue";

export default {
    components: {
        Pie,
        Bar,
        Bubble,
    },
    props: {
        charts: {
            type: Array,
            required: true,
        },
        height: {
            type: String,
            default: "100%"
        },
        width: {
            type: String,
            default: "100%",
        },
    },
    data() {
        return {
            slide: 0,
            loading: true,
        }
    },
}
</script>

<style lang="css" scoped>
.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    width: 100%;
    height: 100%;
}

.chart-parent {
    width: 100%;
}
</style>